// People-management function handles (PER-*, ADM-*; bead hf-e3b-circle-people-r3z.1).
//
// The browser imports only generated Convex references. Capability decisions remain
// in the boundary: the list result carries `canManage`, and every mutation checks
// `people.manage` again when it reaches the server.

import type { FunctionReturnType } from "convex/server";

import { api } from "../../../../convex/_generated/api";
import type { Id } from "../../../../convex/_generated/dataModel";

export const peopleQueries = {
  list: api.domain.people.listPeople,
} as const;

export const peopleMutations = {
  create: api.domain.people.createPerson,
  updatePerson: api.domain.people.updatePerson,
  updateMembership: api.domain.memberships.updateMembership,
  deactivate: api.domain.memberships.deactivateMembership,
} as const;

export type PeopleDirectoryResult = FunctionReturnType<typeof peopleQueries.list>;
export type CreatePersonResult = FunctionReturnType<typeof peopleMutations.create>;
export type UpdatePersonResult = FunctionReturnType<typeof peopleMutations.updatePerson>;
export type UpdateMembershipResult = FunctionReturnType<typeof peopleMutations.updateMembership>;
export type DeactivateMembershipResult = FunctionReturnType<typeof peopleMutations.deactivate>;
export type PeopleMutationResult = CreatePersonResult | UpdatePersonResult | UpdateMembershipResult;

/** Bridge a server-returned contract id back to the generated Convex mutation id. */
export function personDocumentId(value: string): Id<"people"> {
  return value as Id<"people">;
}
